const ANTHROPIC_API_KEY = import.meta.env.VITE_ANTHROPIC_API_KEY || ''
const ANTHROPIC_API_URL = 'https://api.anthropic.com/v1/messages'

interface Message {
  role: 'user' | 'assistant'
  content: string
}

interface ClaudeResponse {
  content: Array<{
    type: string
    text: string
  }>
}

export const llmApi = {
  async chat(messages: Message[], systemPrompt?: string): Promise<string> {
    if (!ANTHROPIC_API_KEY || ANTHROPIC_API_KEY.trim() === '') {
      throw new Error('Anthropic API key not configured. Please add VITE_ANTHROPIC_API_KEY to your .env file.')
    }

    try {
      const response = await fetch(ANTHROPIC_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': ANTHROPIC_API_KEY,
          'anthropic-version': '2023-06-01'
        },
        body: JSON.stringify({
          model: 'claude-3-5-sonnet-20241022',
          max_tokens: 1024,
          messages: messages,
          system: systemPrompt
        })
      })

      if (!response.ok) {
        const errorText = await response.text()
        throw new Error(`Claude API error: ${response.status} ${response.statusText} - ${errorText}`)
      }

      const data: ClaudeResponse = await response.json()
      return data.content[0]?.text || 'I apologize, but I didn\'t receive a valid response.'
    } catch (error) {
      console.error('Error calling Claude API:', error)
      throw error
    }
  }
}
